var map = {
	"./bernex.jpg": 36,
	"./carouge.jpg": 37,
	"./chenes_bougeries.jpg": 38,
	"./geneve.jpg": 39,
	"./lancy.jpg": 40,
	"./le_grand_saconnex.jpg": 41,
	"./meyrin.jpg": 42,
	"./onex.jpg": 43,
	"./plan_les_ouates.jpg": 44,
	"./thonex.jpg": 45,
	"./vernier.jpg": 46,
	"./versoix.jpg": 47,
	"./veyrier.jpg": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;